export default "__VITE_ASSET__DkfhBbtg__"